// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-new-acc.autotaxatiepartners.nl'
}

export const environmentInruilmodule = {
  application: 'atp-voertuigspecs',
  password: 'vi]Y]P?D9+tiBn.mj-XlcmU-6YA'
};

export const environmentAVPInruilmodule = {
  application: 'avp-storefront',
  password: 'CsIXsh8Pd7^aTe@u52nrlBqfh',
  frameUrl: 'https://acc-wordpress.autoverkooppartner.nl/'
};

export const environmentDashboard = {
  application: 'atp-dashboard',
  level: 'application',
  password: '53FdUOpyUh2zVEQhcEPf',
  url: 'https://acc.dashboard.autotaxatiepartners.nl'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
